<div class="page-container unified">
  <div class="login-content-container">
    <div class="login-container col-12 col-md-6 col-lg-5">
      <div class="logo-container mb-5">
        <img
          src="{{ './assets/rb-blue-logo.png' }}"
          class="col-8 col-md-6 col-lg-4"
          alt="RightBridge"
        />
      </div>

      <div class="login-component-container">
        <div class="text-container mb-5">
          <h2>Welcome back!</h2>
          <p>Log in to your account</p>
        </div>

        <div class="login-form-container">
          <form>
            <mat-form-field floatPlaceholder="auto" class="col-12">
              <mat-label>Username</mat-label>
              <input
                matInput
                name="'username'"
                required
                [placeholder]="'Username'"
                [type]="'text'"
                [formControl]="username"
              />
              <mat-error>A username is required</mat-error>
            </mat-form-field>
            <mat-form-field floatPlaceholder="auto" class="col-12">
              <mat-label>Password</mat-label>
              <input
                matInput
                name="'password'"
                required
                [placeholder]="'Password'"
                [type]="'password'"
                [formControl]="password"
              />
              <mat-error>A password is required</mat-error>
            </mat-form-field>
            <div class="login-button-container col-12 mb-2">
              <button
                class="col-12"
                matButton="elevated"
                color="primary"
                id="login-button"
                [type]="'submit'"
                (click)="login()"
              >
                Log In<mat-icon>input</mat-icon>
              </button>
            </div>
          </form>
        </div>
        @if (failed) {
          <div class="failed">
            @if (loginError === 'Invalid') {
              <p class="col-12 warning-text">
                Sorry, it looks like either your username or password are
                incorrect. Please double check them and try again.
              </p>
            } @else if (loginError === 'Locked') {
              <p class="col-12 warning-text">
                Your account is locked due to multiple failed log in attempts.
                Please contact your technical support for assistance.
              </p>
            } @else if (
              loginError === 'Bad request' ||
              loginError === 'Unavailable' ||
              loginError === 'Server error'
            ) {
              <p class="col-12 warning-text">
                The server appears to be having an issue. Our team is on top of
                it! Please try again later.
              </p>
            }
          </div>
        }
        <ngx-loading
          [show]="loading"
          [config]="{ fullScreenBackdrop: false }"
        />
      </div>
    </div>

    <div class="login-decoration-container col-12 col-md-6 col-lg-7">
      <div class="content">
        <img
          src="{{ './assets/rightbridge-logo.png' }}"
          alt="RightBridge logo"
          id="Polygon-1"
          class="unified-logo"
        />
        <mat-icon id="Polygon-2" class="app-button-icon" svgIcon="aw_icon" />
        <mat-icon id="Polygon-3" class="app-button-icon" svgIcon="pp_icon" />
        <mat-icon id="Polygon-4" class="app-button-icon" svgIcon="iw_icon" />
        <mat-icon id="Polygon-5" class="app-button-icon" svgIcon="lw_icon" />
        <mat-icon id="Polygon-6" class="app-button-icon" svgIcon="cm_icon" />

        <app-background-decoration />
      </div>
    </div>
  </div>
</div>
